import { connect } from 'react-redux'
import { reduxForm, destroy, initialize, reset } from 'redux-form'
import { post } from '../modules/route'

import component from 'components/Routes/New'

const formName = 'new-route'
const fields = ['name', 'desc', 'region']

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  onSubmit: (data) => {
    dispatch(post(data))
    dispatch(reset(formName))
    dispatch(destroy(formName))
    dispatch(initialize(formName, {}, fields))
  }
})

const mapStateToProps = (state) => ({
  route: state.route
})

const form = reduxForm({
  form: formName,
  fields,
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.name) errors.name = 'Please enter a name.'

    return errors
  }
})(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/Routes/containers/NewRouteContainer.js